+function ($) {
    'use strict';

    var ImagePickerMultiple = function (element, option) {
        this.element = $(element);
        this.fileInputs = this.element.find('input[type="file"]');
        this.amountBadget = this.element.find('.badget');

        var self = this;
        this.fileInputs.bind('change', function () {
            self.loadImage(this);
        });
    };

    ImagePickerMultiple.prototype.loadImage = function (input) {
        var countImage = input.files.length;
        this.amountBadget.text('');
        this.amountBadget.text(countImage);
        var files = input.files;

        for (var i = 0; i < files.length; i++) {
            if (!files[i].type.match('image.*')) {
                input.attr('data-tooltip-msg', 'Файлы могут быть только image типов');
                return;
            }
        }
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new ImagePickerMultiple(this, options)
        });
    };



    var old = $.fn.ImagePickerMultiple;

    $.fn.ImagePickerMultiple = constructor;
    $.fn.ImagePickerMultiple.constructor = constructor;

    $.fn.ImagePickerMultiple.noConflict = function () {
        $.fn.ImagePickerMultiple = old;
        return this;
    }
}(jQuery);